import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { getExpenseGroups } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/expenses/constants.ts';
import { ExpenseGroup } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/expenses/ExpenseGroup.tsx';
import type { IExpensesSectionProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/expenses/types.ts';
import {
  BorrowerType,
  FinancialStatementForm,
  type TFinancialConditionFormValues,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

export const ExpensesSection: React.FC<IExpensesSectionProps> = ({ disabled }) => {
  const { watch } = useFormContext<TFinancialConditionFormValues>();
  const borrowerType = watch('borrowerType')?.value;
  const financialStatementForm = watch('financialStatementForm')?.value as
    FinancialStatementForm | undefined;
  const isLegalEntity = borrowerType === BorrowerType.LegalEntity;

  if (!isLegalEntity || !financialStatementForm) {
    return null;
  }

  return (
    <Box sx={documentGenerationFormStyles.section}>
      <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
        11. Розшифровка витрат
      </Typography>
      {getExpenseGroups(financialStatementForm).map((group) => (
        <ExpenseGroup key={group.name} {...group} disabled={disabled} />
      ))}
    </Box>
  );
};
